export enum VintraceUserRoleCode {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CELLARHAND = 'CELLARHAND',
  REPORTING = 'REPORTING',
  WINEMAKER = 'WINEMAKER',
}
